import { IndicatorStatus } from '../sportsbook-indicator';
import { BetSettlementStatus } from '../../sportsbook-types';
import BetTextKeys from './sportsbook-bet-text-keys';

export const colorByStatus = {
	[BetSettlementStatus.OPEN]: 'var(--system-orange);',
	[BetSettlementStatus.WON]: 'var(--system-success);',
	[BetSettlementStatus.LOST]: 'var(--system-error);',
	[BetSettlementStatus.CASHOUT]: 'var(--system-success);',
	[BetSettlementStatus.CANCELLED]: 'var(--main-text-supportive);'
};

export const returnsLabelByStatus = {
	[BetSettlementStatus.OPEN]: BetTextKeys.TICKET_POSSIBLE_WIN_LABEL,
	[BetSettlementStatus.WON]: BetTextKeys.TICKET_WON_LABEL,
	[BetSettlementStatus.LOST]: BetTextKeys.TICKET_LOST_LABEL,
	[BetSettlementStatus.CASHOUT]: BetTextKeys.TICKET_CASHED_OUT_LABEL,
	[BetSettlementStatus.CANCELLED]: BetTextKeys.TICKET_CANCELLED_LABEL
};

export const eventResultTextByStatus = {
	[BetSettlementStatus.WON]: BetTextKeys.TICKET_WON_LABEL,
	[BetSettlementStatus.LOST]: BetTextKeys.TICKET_LOST_LABEL,
	[BetSettlementStatus.OPEN]: BetTextKeys.TICKET_OPEN_LABEL,
	[BetSettlementStatus.CASHOUT]: BetTextKeys.TICKET_CASHED_OUT_LABEL,
	[BetSettlementStatus.CANCELLED]: BetTextKeys.TICKET_EVENT_CANCELLED_LABEL
};

export const BetSettlementStatusToIndicatorStatusMap = {
	[BetSettlementStatus.OPEN]: IndicatorStatus.NEUTRAL,
	[BetSettlementStatus.WON]: IndicatorStatus.SUCCESS,
	[BetSettlementStatus.LOST]: IndicatorStatus.FAILURE,
	[BetSettlementStatus.CASHOUT]: IndicatorStatus.SUCCESS,
	[BetSettlementStatus.CANCELLED]: IndicatorStatus.NEUTRAL
};
